import axiosInstance from "../api/api";

const MeetingReportService = {
    list: function (dateFrom, dateTo) {
        let url = "/api/meetingReport/";
        const params = new URLSearchParams();
        if (dateFrom) params.append("dateFrom", dateFrom);
        if (dateTo) params.append("dateTo", dateTo);
        if (params.toString()) url += `?${params.toString()}`;
        
        return axiosInstance({
            url: url,
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/meetingReport/${uniqueId}`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/meetingReport/${uniqueId}`,
            method: "DELETE",
        });
    },
    create: function (formData) {
        return axiosInstance({
            url: `/api/meetingReport/`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/meetingReport/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default MeetingReportService;
